// extracted by mini-css-extract-plugin
module.exports = {"body":"Tags_body__2kbsN","active":"Tags_active__3IxAv"};